import React from "react";
import './app.component.scss'
import SidebarMenu from "./sidebar-menu/sidebar-menu.component";
import HeaderComponent from "./header/header.component";
import ListComponent from "./base-content/list/list.component";

const ListApp = () => {
    return (
<div className="container-fluid">
  <div className="row">
      <div className="col-sm-auto sidebar-menu sticky-top">
        <SidebarMenu />
      </div>
      <div className="col-sm min-vh-100 p-0">
        <div>
            <HeaderComponent />
            <ListComponent />
        </div>
      </div>
  </div>
</div>
    );
}

export default ListApp;